// Central data source for The Treasure Threads site.

export const BRAND = {
    name: "The Treasure Threads",
    parent: "The Treasure Threads ",
    tagline: "Timeless Craftsmanship. Curated Since the Early 1980s.",
    phone: "+66 9688 37860",
    phoneRaw: "66968837860",
    email: "jan@thetreasurethreads.com",
    address: "87/120, Mubaan Kankanork 1, Sankampang Road, Chiang Mai 50130, Thailand",
    founded: "Early 1980s",
    logo: "https://customer-assets.emergentagent.com/job_10ffbf8a-7978-4bb4-80a6-276f854ee641/artifacts/12qmqww5_image-Photoroom%20%281%29.png",
};

// Images (curated by design agent — Unsplash / Pexels editorial)
export const IMG = {
    heroHome: "images2/antique-chair-decorated-oriental-carpet.jpg",
    heroAbout: "https://images.unsplash.com/photo-1660796334938-cf0b03be7e6d?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
    heroCollections: "images2/kids-table-restaurant-with-moroccan-style.jpg",
    carpets: "images/pexels-paolobici-32860533.jpg",
    carpets2: "images/pexels-photo_share07-245701175-15042625.jpg",
    carpets3: "images2/carpet_image.jpeg",
    carpets4: "images2/traditional-red-persian-style-area-rug-with-ornate-floral-medallion-design.jpg",
    carpets5: "images3/pexels-paolobici-31917723.jpg",
    sculptures: "https://images.unsplash.com/photo-1765443254299-eb5f69ab85a9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    sculptures2: "images2/view-ancient-pottery-vessels-earthenware.jpg",
    sculptures3: "images3/view-bust-figure-from-ancient-greece.jpg",
    sculptures4: "images3/view-buddha-statuette.jpg",
    sculptures5: "images3/stone-sculpture-serene-buddha-meditation-pose.jpg",
    cashmere: "images2/close-up-bunch-colorful-threads.jpg",
    cashmere2: "images/pexels-nurse-438605684-33595151.jpg",
    cashmere3: "images2/shawl-isolated-white-background-high-quality-high-resolution.jpg",
    cashmere4: "images2/textile-background-soft-shiny-silk-texture.jpg",
    cashmere5: "images2/smooth-textured-handkerchief-hanging.jpg",
    cashmere6: "images3/elaborate-indian-pashmina-shawl-with-paisley-designs.jpg",
    jewelry: "images/pexels-kunal-lakhotia-781256899-32988666.jpg",
    jewelry2: "images3/portrait-young-woman-with-earrings-with-gems-isolated.jpg",
    silkFashion: "images/pexels-veronika-kuracheva-2158899242-38545837.jpg",
    loro: "images3/close-up-wool-texture-details.jpg",
    silkFashion2: "images/pexels-tamanna-rumee-52377920-8007352.jpg",
    silkFashion3: "images2/satin-texture-background.jpg",
    womenFashion: "images/pexels-anna-danilina-241843489-20376483.jpg",
    womenFashion2: "images2/beautiful-vertical-shot-person-covered-scarf-with-different-patterns.jpg",
    silkAccessories: "images/pexels-khaliifah-hussein-1904370898-34225152.jpg",
    silkAccessories2: "images2/scarf_premium.jpeg",
    silkAccessories3: "images2/young-woman-wearing-handkerchief-her-face.jpg",
    carvings: "images/pexels-cute-clicks-2159602770-36492217.jpg",
    carvings2: "images/pexels-breaks-21644747.jpg",
    carvings3: "images2/floral-carving-with-arabic-calligraphy.jpg",
    carvings4: "images2/fragment-ancient-carved-wooden-door-ornate-background.jpg",
    artisanWork: "https://images.unsplash.com/photo-1660796334938-cf0b03be7e6d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    showroom: "https://images.pexels.com/photos/13068364/pexels-photo-13068364.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1800",
    // Reusable variations with different crop instructions
    carpetsTall: "https://images.unsplash.com/photo-1671624760664-8946fd3037a3?crop=entropy&cs=srgb&fm=jpg&q=85&w=900&h=1300&fit=crop",
    sculpturesTall: "https://images.unsplash.com/photo-1765443254299-eb5f69ab85a9?crop=entropy&cs=srgb&fm=jpg&q=85&w=900&h=1300&fit=crop",
    cashmereTall: "https://images.unsplash.com/photo-1603906650843-b58e94d9df4d?crop=entropy&cs=srgb&fm=jpg&q=85&w=900&h=1300&fit=crop",
    jewelryTall: "https://images.unsplash.com/photo-1726195641634-a8940e99719c?crop=entropy&cs=srgb&fm=jpg&q=85&w=900&h=1300&fit=crop",
    silkFashionTall: "https://images.unsplash.com/photo-1704775990248-4c1c1a276b4f?crop=entropy&cs=srgb&fm=jpg&q=85&w=900&h=1300&fit=crop",
    artisanTall: "https://images.unsplash.com/photo-1660796334938-cf0b03be7e6d?crop=entropy&cs=srgb&fm=jpg&q=85&w=900&h=1300&fit=crop",
};

// Home hero carousel — 5 editorial images that auto-cycle every 3s.
// Each image is served large enough for retina hero display.
export const HERO_CAROUSEL = [
    {
        src: "images2/3d-prayer-mat-serene-islamic-environment.jpg",
        alt: "Antique Persian silk carpet with intricate monochrome pattern",
    },
    {
        src: "images2/antique-chair-decorated-oriental-carpet.jpg",
        alt: "Rare bronze temple sculpture with dramatic lighting",
    },
    {
        src: "images2/vietnamese-artisan-hand-embroidering-silk-tapestry-with-floral-patterns.jpg",
        alt: "Luxury cashmere shawl draped in editorial style",
    },
    {
        src: "images2/close-up-staircase-covered-with-carpet.jpg",
        alt: "Fine handcrafted jewelry from Asia",
    },
    {
        src: "images3/woman-weaving-carpet.jpg",
        alt: "Warmly lit heritage emporium interior with silk carpets and antiques",
    },
];

export const HERITAGE_STATS = [
    { value: "40+", label: "Years of Experience" },
    { value: "1000+", label: "Curated Artisan Pieces" },
    { value: "50+", label: "Countries Served" },
    { value: "100%", label: "Handcrafted" },
];

export const FEATURED_CATEGORIES = [
    {
        slug: "silk-carpets",
        title: "Hand Knotted Silk Carpets",
        blurb: "Hand knotted masterpieces crafted using centuries-old weaving techniques.",
        image: IMG.carpets3,
    },
    {
        slug: "sculptures",
        title: "Antique Sculptures",
        blurb: "Rare bronze, brass and wooden sculptures inspired by Asian heritage.",
        image: IMG.sculptures4,
    },
    {
        slug: "cashmere",
        title: "Luxury Shawls",
        blurb: "Pure Cashmere, Silk and Fine Wool collections.",
        image: IMG.cashmere6,
    },
    {
        slug: "jewelry",
        title: "Fine Jewelry",
        blurb: "Elegant handcrafted jewellery for collectors and connoisseurs.",
        image: IMG.jewelry2,
    },
    {
        slug: "womens-fashion",
        title: "Women's Fashion",
        blurb: "Premium dresses and artisan garments.",
        image: IMG.silkFashion3,
    },
    {
        slug: "silk-accessories",
        title: "Silk Accessories",
        blurb: "Hand woven scarves and luxury textiles.",
        image: IMG.silkAccessories2,
    },
];

export const SIGNATURE_COLLECTIONS = [
    { title: "Hand Knotted Silk Carpets", image: IMG.carpets3, span: "row-span-2" },
    { title: "Antique Bronze Collection", image: IMG.sculptures2, span: "" },
    { title: "Cashmere Collection", image: IMG.cashmere, span: "" },
    { title: "Loro Piana Knitwear", image: IMG.loro, span: "row-span-2" },
    { title: "Wood Carvings", image: IMG.carvings3, span: "" },
    { title: "Hand Woven Silk", image: IMG.silkFashion2, span: "" },
    { title: "Rare Sculptures", image: IMG.sculptures5, span: "" },
    { title: "Heritage Jewelry", image: IMG.jewelry2, span: "" },
];

export const WHY_CHOOSE_US = [
    { title: "Established Since Early 1980s", icon: "sparkles" },
    { title: "Genuine Artisan Products", icon: "handshake" },
    { title: "Museum Quality Antiques", icon: "landmark" },
    { title: "Worldwide Shipping", icon: "globe" },
    { title: "Carefully Curated Collections", icon: "gem" },
    { title: "Personal Shopping Assistance", icon: "compass" },
];

// Hotel & retail presence grouped by country.
// Logos are pulled from the Clearbit public logo CDN and rendered in a
// pure-white monochrome silhouette to match the all-black theme.
//
// EDITABLE FIELDS per store:
//   - `logo`     : direct URL to a custom logo image (overrides hotelDomain lookup)
//   - `initials` : custom monogram text to show when no logo is available
//                   (defaults to first letters of `hotel` / `venue` / `name`)
// Simply add or edit these fields to override what a card displays.
export const PRESENCE = [
    {
        country: "Thailand",
        stores: [
            {
                name: "The Treasure Threads",
                subtitle: "Flagship Showroom",
                location: "Chiang Mai",
                flagship: true,
                logo: "", // flagship always uses BRAND.logo; leave blank
                initials: "TT",
            },
            {
                name: "Allure",
                hotel: "Hyatt Regency",
                hotelDomain: "hyatt.com",
                location: "Koh Samui",
                logo: "",
                initials: "",
            },
            {
                name: "Cashmere",
                hotel: "InterContinental",
                hotelDomain: "ihg.com",
                location: "Koh Samui",
                logo: "",
                initials: "",
            },
            {
                name: "Allure by TCI",
                hotel: "The Ritz-Carlton",
                hotelDomain: "ritzcarlton.com",
                location: "Koh Samui",
                logo: "",
                initials: "",
            },
        ],
    },
    {
        country: "Cambodia",
        stores: [
            {
                name: "Silk & Statue",
                hotel: "Sofitel Angkor",
                hotelDomain: "",
                location: "Siem Reap",
                logo: "",
                initials: "",
            },
            {
                name: "Boutique Shop",
                hotel: "J7 Angkor Hotel",
                hotelDomain: "",
                location: "J7 Siem Reap",
                logo: "",
                initials: "BS",
            },
            {
                name: "Boutique Shop",
                hotel: "Memoire d'Anhkor",
                hotelDomain: "",
                location: "Siem Reap",
                logo: "",
                initials: "BS",
            },
            {
                name: "Boutique Shop",
                hotel: "Park Hyatt",
                hotelDomain: "hyatt.com",
                location: "Siem Reap",
                logo: "",
                initials: "",
            },
            {
                name: "Khmer Art",
                hotel: "Raffles Grand Hôtel d'Angkor",
                hotelDomain: "raffles.com",
                location: "Siem Reap",
                logo: "",
                initials: "",
            },
            {
                name: "S. B. Handicrafts",
                hotel: "Anantara Angkor",
                hotelDomain: "anantara.com",
                location: "Siem Reap",
                logo: "",
                initials: "",
            },
            {
                name: "D'Mouj",
                hotel: "Courtyard by Marriott",
                hotelDomain: "marriott.com",
                location: "Siem Reap",
                logo: "",
                initials: "",
            },
            {
                name: "Art Galleria",
                hotel: "Prince d'Angkor Hotel",
                location: "Siem Reap",
                logo: "",
                initials: "AG",
            },
            {
                name: "Heritage Old Market",
                venue: "Pub Street",
                location: "Siem Reap",
                logo: "",
                initials: "HM",
            },
            {
                name: "Cashmere",
                venue: "Pub Street",
                location: "Siem Reap",
                logo: "",
                initials: "CM",
            },
            {
                name: "Boutique Shop",
                hotel: "Raffles Le Royal",
                hotelDomain: "raffles.com",
                location: "Phnom Penh",
                logo: "",
                initials: "",
            },
        ],
    },
    {
        country: "India",
        stores: [
            {
                name: "Boutique India",
                venue: "Fort Kochi",
                location: "Kochi, Kerala",
                logo: "",
                initials: "BI",
            },
            {
                name: "Boutique India",
                location: "Trivandrum",
                logo: "",
                initials: "BI",
            },
        ],
    },
    {
        country: "Vietnam",
        stores: [
            {
                name: "Allure",
                hotel: "Renaissance Riverside",
                hotelDomain: "renaissance.com",
                location: "Saigon",
                logo: "",
                initials: "",
            },
        ],
    },
    {
        country: "Mauritius",
        stores: [
            {
                name: "L'essence",
                hotel: "L'essence d'Art",
                hotelDomain: "",
                location: "Port Luis Mauritius",
                logo: "",
                initials: "LE",
            },
        ],
    },
    
];

export const TESTIMONIALS = [
    {
        quote: "One of the finest collections of authentic Asian handicrafts I've ever seen.",
        author: "Interior Designer",
        location: "London",
    },
    {
        quote: "Every carpet we purchased became the centrepiece of our home.",
        author: "Private Collector",
        location: "Singapore",
    },
    {
        quote: "A rare emporium where every piece feels chosen with a curator's eye — timeless, quiet, extraordinary.",
        author: "Art Advisor",
        location: "Paris",
    },
    {
        quote: "Jan and his team source pieces you simply cannot find anywhere else in the world.",
        author: "Hospitality Group Buyer",
        location: "Dubai",
    },
];

export const VALUES = [
    "Authenticity",
    "Quality",
    "Heritage",
    "Craftsmanship",
    "Relationships",
    "Timeless Design",
];

export const EXPERTISE = [
    "Luxury Textiles",
    "Fine Jewelry",
    "Antique Sculptures",
    "Museum Quality Carpets",
    "Traditional Crafts",
    "Interior Collectibles",
];

export const PROCESS = [
    { step: "01", title: "Source", detail: "Directly from master artisans across Asia." },
    { step: "02", title: "Inspect", detail: "Every piece is examined for authenticity and craftsmanship." },
    { step: "03", title: "Curate", detail: "Only exceptional works enter the collection." },
    { step: "04", title: "Present", detail: "Displayed in our Chiang Mai emporium as timeless collections." },
    { step: "05", title: "Deliver", detail: "Carefully packaged and shipped worldwide." },
];

export const CATEGORY_DETAILS = [
    {
        slug: "silk-carpets",
        title: "Hand Knotted Silk Carpets",
        option: "Carpets",
        description: "Luxury Persian and Asian inspired silk masterpieces, hand‑knotted by master craftsmen. Each masterpiece is woven knot by knot, a creation that takes years to perfect. Patience becomes luxury, and every knot tells a story of heritage and artistry.",
        items: ["Silk Carpets", "Oriental Carpets", "Traditional Rugs", "Luxury Floor Coverings"],
        image: IMG.carpets3,
    },
    {
        slug: "sculptures",
        title: "Antique Sculptures",
        option: "Sculptures",
        description: "Rare sculptural works in bronze, brass and hand-carved wood. Rare antique sculptures that showcase rich heritage, intricate detailing, and enduring artistic value.",
        items: ["Bronze Statues", "Brass Sculptures", "Wooden Sculptures", "Temple Art", "Decorative Collectibles"],
        image: IMG.sculptures4,
    },
    {
        slug: "jewelry",
        title: "Fine Jewelry",
        option: "Jewelry",
        description: "Exquisite handcrafted jewelry featuring timeless designs and exceptional artistry for every occasion. Handcrafted jewelry celebrating traditional Asian design, precious metals and gemstones, made for collectors and connoisseurs.",
        items: ["Gold Jewelry", "Silver Jewelry", "Gemstone Jewelry", "Traditional Designs", "Luxury Accessories"],
        image: IMG.jewelry2,
    },
    {
        slug: "cashmere",
        title: "Cashmere Collection",
        option: "Cashmere",
        description: "Premium cashmere garments renowned for their unmatched softness, warmth, and refined elegance, that are sourced and finished to the highest standards for the discerning wardrobe.",
        items: ["Pure Cashmere Shawls", "Luxury Wraps", "Fine Wool Scarves", "Winter Collection"],
        image: IMG.cashmere6,
    },
    {
        slug: "loro-piana-knitwear",
        title: "Loro Piana Knitwear",
        option: "Knitwear",
        description: "A carefully curated selection of Loro Piana knitwear and Italian-inspired luxury fashion. Luxurious knitwear crafted from the world's finest fibers, offering exceptional comfort and timeless style.",
        items: ["Luxury Knitwear", "Premium Wool", "Italian-inspired Fashion"],
        image: IMG.loro,
    },
    {
        slug: "womens-fashion",
        title: "Women's Fashion",
        option: "Dresses",
        description: "Graceful silk apparel for women, combining luxurious fabrics with sophisticated contemporary designs. Silk dresses, handcrafted apparel and designer tunics designed to be worn for a lifetime.",
        items: ["Silk Dresses", "Handcrafted Apparel", "Designer Tunics", "Luxury Garments"],
        image: IMG.silkFashion3,
    },
    {
        slug: "silk-accessories",
        title: "Silk Accessories",
        option: "Silk Accessories",
        description: "Hand woven silk scarves, brocade bed covers, cushion covers, table runners and other luxury textiles. Silk accessories designed to add a touch of luxury to every ensemble.",
        items: ["Silk Scarves", "Brocade Bed Covers", "Cushion Covers", "Table Runners", "Decorative Accessories"],
        image: IMG.silkAccessories2,
    },
    {
        slug: "wood-carvings",
        title: "Wood Carvings",
        option: "Wood Carvings",
        description: "Intricately handcrafted wooden masterpieces that celebrate traditional craftsmanship and artistic excellence. Traditional wood-carved panels, wood statues and wall art which reflects generations of craftsmanship.",
        items: ["Decor Panels", "Traditional Wood Statues", "Temple Carvings", "Wall Art"],
        image: IMG.carvings4,
    },
];

export const INTERESTED_IN_OPTIONS = [
    "Carpets",
    "Shawls",
    "Jewelry",
    "Sculptures",
    "Cashmere",
    "Knitwear",
    "Dresses",
    "Wood Carvings",
    "Silk Accessories",
    "Other",
];
